import { ErrorDialog } from "shared/boot/alert";
import { track } from "shared/boot/analytics";
import { getLocaleText } from "shared/boot/i18n";
import ModalService from "shared/modals/ModalService";
import MediaRequestService from "shared/services/api/MediaRequestService";

export default function useMediaItemRequest() {
  async function openMediaItemRequestModalWithDuplicateCheck(data) {
    let mediaItemCount = 0;

    const {
      duplicateCheckMention,
      isInstantDownload,
      mention,
      origin,
      shouldShowInstantEditButton,
      stream,
      type,
    } = data;

    try {
      mediaItemCount = (
        await MediaRequestService.findDuplicates(duplicateCheckMention, {
          seconds: 300,
        })
      ).length;
    } catch (error) {
      ErrorDialog(
        getLocaleText("actionsheet.errors.duplicate_media_item"),
        error
      );
    } finally {
      if (mediaItemCount > 0) {
        openDuplicateMediaItemModal(
          duplicateCheckMention,
          origin,
          type,
          isInstantDownload,
          shouldShowInstantEditButton
        );
      } else if (isInstantDownload) {
        openCreateInstantMediaItemModal(mention, stream, type);
      } else {
        openRequestMediaItemModal(mention, origin, stream);
      }
    }
  }

  return { openMediaItemRequestModalWithDuplicateCheck };
}

function openCreateInstantMediaItemModal(mention, stream, type) {
  ModalService.open("CreateInstantDownloadModal", {
    props: {
      mention,
      stream,
      type,
    },
  });

  track("Instant Edit Media Item modal opened", {
    id: mention.id,
    streamId: stream.id,
    type: mention.type,
  });
}

function openDuplicateMediaItemModal(
  duplicateCheckMention,
  origin,
  type,
  isInstantDownload,
  shouldShowInstantEditButton
) {
  ModalService.open("DuplicateMediaItemTranscriptRequestModal", {
    props: {
      isInstantDownload,
      mention: duplicateCheckMention,
      origin,
      shouldShowInstantEditButton,
      type,
    },
  });

  track("Opened Duplicate Media Item Modal", {
    id: duplicateCheckMention.id,
    type,
  });
}

function openRequestMediaItemModal(mention, origin, stream) {
  ModalService.open("RequestMediaItemModal", {
    props: {
      mention,
      origin,
      stream,
    },
  });

  track("Opened Request Media Item Modal", {
    id: mention.id,
    streamId: stream?.id,
    type: mention.type,
  });
}
